(() => {
  // Never hide content inside the theme editor or for users who prefer reduced motion.
  if (window.Shopify && window.Shopify.designMode) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  const STAGGER = '.ht-card, .ht-cat, .ht-bcard, .ht-assure__card, .ht-vrev-card, .ht-live__card, .ht-tile';

  const init = () => {
    // Skip the first section: it is above the fold and should render immediately.
    const sections = [...document.querySelectorAll('main .shopify-section')].slice(1);
    if (!sections.length) return;

    document.documentElement.classList.add('ht-motion');

    const io = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          const el = entry.target;
          el.classList.add('ht-in');
          io.unobserve(el);
          // Drop the helper classes once the section and its staggered cards have finished,
          // so hover transforms work afterwards. (Waiting on animationend raced with the cards.)
          setTimeout(() => el.classList.remove('ht-reveal', 'ht-in'), 1600);
        }
      },
      { threshold: 0.08, rootMargin: '0px 0px -30px 0px' }
    );

    for (const el of sections) {
      // Sections already visible on load are left alone, so nothing flashes.
      if (el.getBoundingClientRect().top < window.innerHeight) continue;
      el.querySelectorAll(STAGGER).forEach((card, i) => {
        card.style.setProperty('--ht-i', String(i % 4));
      });
      el.classList.add('ht-reveal');
      io.observe(el);
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
